import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslIcon } from '@usecapsule/react-components';
import { styled } from 'styled-components';
import { useModalStore } from '../../stores/index.js';
import { useThemeStore } from '../../stores/theme/useThemeStore.js';
import { useGoBack } from '../../hooks/useGoBack.js';
import { AccountSelect, ChainSelect } from './Selects.js';
import { ModalStep } from '../../utils/steps.js';
import { HeaderButton } from '@usecapsule/react-common';
export const Controls = ({ onClose }) => {
    const bareModal = useThemeStore(state => state.bareModal);
    const hasPreviousStep = useModalStore(state => state.hasPreviousStep());
    const step = useModalStore(state => state.step);
    const isFullyLoggedIn = useModalStore(state => state.isFullyLoggedIn);
    const goBack = useGoBack();
    const shouldShowSelects = [ModalStep.ACCOUNT_MAIN, ModalStep.CHAIN_SWITCH, ModalStep.ADD_FUNDS].includes(step);
    const handleBackClick = () => {
        goBack();
    };
    return (_jsxs(Container, { children: [_jsx(BackButton, { variant: "ghost", style: {
                    visibility: hasPreviousStep ? 'visible' : 'hidden',
                }, onClick: handleBackClick, children: _jsx(CpslIcon, { icon: "arrow" }) }), _jsx(MiddleContainer, { children: shouldShowSelects && isFullyLoggedIn && (_jsxs(_Fragment, { children: [_jsx(ChainSelect, {}), _jsx(AccountSelect, {})] })) }), _jsx(CloseButton, { bareModal: bareModal, variant: "ghost", onClick: onClose, children: _jsx(CpslIcon, { icon: "close" }) })] }));
};
const Container = styled.div `
  position: absolute;
  width: 100%;
  top: 16px;

  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
const MiddleContainer = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const CloseButton = styled(HeaderButton) `
  transform: rotate(180deg);
  visibility: ${({ bareModal }) => (bareModal ? 'hidden' : 'visible')};
`;
const BackButton = styled(HeaderButton) `
  transform: rotate(180deg);
`;
